"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valeggio-sul-mincio": {
    "07bff808": [{
      "hkey": "8eca4352",
      "slug": "vanoni-remelli",
      "name": "Vanoni-Remelli",
      "primary": true,
      "skipSearch": false
    }],
    "vanoni": [{
      "hkey": "8eca4352",
      "slug": "vanoni-remelli",
      "name": "Vanoni-Remelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fb5419c0": [{
      "hkey": "6dd9d4c2",
      "slug": "santa-lucia-ai-monti",
      "name": "Santa Lucia ai Monti",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "6dd9d4c2",
      "slug": "santa-lucia-ai-monti",
      "name": "Santa Lucia ai Monti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;